import { createFileRoute } from "@tanstack/react-router";
import { CookiePage } from "../../../features/privacy";

export const Route = createFileRoute("/$lang/_layout/cookie-policy")({
  component: CookiePage,
});
